<template>
    <div class="container">
        <Header></Header>
        <div>
            <grid v-if="windowWidth>maxMobilSize" :columns="gridColumns" :tableConfigVisible="tableConfigVisible" :user="user" :users="users" :page="pageIs" :data="gridData"></grid>
        </div>

        <notifications group="foo" style="margin-right:5%;margin-top:2%" position="top right" />
    </div>
    
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import Grid from './Grid'
    import GridMobil from "./gridMobil"
    
    export default {
        name: "closedProcesses",
        components: {
            "grid":Grid,
            "gridMobil":GridMobil,
        },
        props: ['user', 'users'],
        data () {
            return {
                firstLoad:true,
                gridColumns:[
                    {prop:'_id',name:"Id",default:true},
                    {prop:'name',name:this.$ml.get('PROCESS_NAME'),default:true,type:"name",valid:true},
                    {prop:'form',name:this.$ml.get('FORM_NAME'),default:true,type:"formObj",valid:true},
                    {prop:'add_date',name:this.$ml.get('CREATION_DATE'), type:"dateObj", default:true, valid:true},
                    {prop:'cuid', name: this.$ml.get('CREATED_BY'), type:"user", default:true},
                ],
                tableConfigVisible:[],
                gridData:[],
                processList: [],
                pageIs:'closedProcesses',
                processName: "",
                listForms: [],
                selectedFormId: "",
                updateProcessData: {},
                isEditMode: false
            }
        },
        computed:{
            ...mapState([
                'baseUrl',
                'windowWidth',
                'maxMobilSize',
                'maxTabletSize',
            ]),
        },
        created() {

        },
        methods: {
            getClosedProcessesF() {
                axios({
                    method:'POST',
                    url:'/getClosedProcesses',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.processList = res.data.content.processes[0]
                            if(this.firstLoad){
                                for(var col in this.gridColumns){
                                    if(this.gridColumns[col]['default']){
                                        this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                                    }
                                }
                            }

                            this.firstLoad=false
                            if(res.data.content.processes){
                                var processList = []
                                let columns = this.gridColumns
                                for (var formObjIter in res.data.content.processes[0]){
                                    let obj={}
                                    let formObj =res.data.content.processes[0][formObjIter]
        
                                    for(var column in columns){
                                        var colInActivity = formObj.hasOwnProperty(columns[column]['prop'])
                                        if(colInActivity){
                                            
                                            let edObj={}
                                             
                                            edObj['val']=formObj[columns[column]['prop']]
                                            
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            obj[columns[column]['prop']]=edObj
                                        }else{
                                            let edObj={}
                                            edObj['val']=null
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            
                                            if(columns[column]['type']=='dateObj'){
                                                let date = {}
                                                date['$date']=''
                                                edObj['val']=date
                                            }
                                            obj[columns[column]['prop']]=edObj
                                        }
                                    }
                                    processList.push(obj)
                                    
                                }
                                this.gridData = processList
                                processList.reverse()
                            }
                        }
                    }
                })
            }, 
        },
        mounted() {
            this.getClosedProcessesF()
        },
    }
</script>

<style scoped>

</style>